<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-2xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] overflow-y-auto custom-scrollbar">

    <div *ngIf="isSaving()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">subscriptions</span>
        {{ isEdit ? 'แก้ไข Subscription' : 'เพิ่ม Subscription' }}
      </h3>
      <button type="button" (click)="onClose()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="space-y-5">
      <div class="flex items-center gap-3 p-4 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800/40">
        <span class="material-icons text-amber-500">place</span>
        <div>
          <p class="text-xs font-bold text-slate-400 uppercase tracking-wider">ลาน (Site)</p>
          <p class="text-sm font-bold text-slate-800 dark:text-slate-100 mt-0.5">
            {{ siteName || siteState.selectedSite()?.name || (siteId ? ('Site ID ' + siteId) : 'กรุณาเลือกลานจาก Sidebar') }}
          </p>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อ <span class="text-rose-500">*</span></label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">label</span>
          <input type="text" placeholder="ชื่อ Subscription" [(ngModel)]="formData.name"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Identify</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">fingerprint</span>
          <input type="text" placeholder="เช่น general, VIP" [(ngModel)]="formData.identify"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Calculate Category</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">category</span>
            <input type="number" placeholder="เช่น 1" [(ngModel)]="formData.calculateCategory"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none">
          </div>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Calculate Type</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">tune</span>
            <input type="number" placeholder="เช่น 1" [(ngModel)]="formData.calculateType"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none">
          </div>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จำนวนเงิน (Fee)</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">payments</span>
          <input type="number" placeholder="0.00" [(ngModel)]="formData.fee"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none">
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Fee</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">receipt</span>
            <select [(ngModel)]="formData.feeId"
              class="w-full pl-10 pr-8 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none appearance-none cursor-pointer">
              <option [ngValue]="null">-- ไม่ระบุ --</option>
              <option *ngFor="let f of fees" [ngValue]="f.id">{{ f.name }}</option>
            </select>
            <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
          </div>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Rate</label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">speed</span>
            <select [(ngModel)]="formData.rateId"
              class="w-full pl-10 pr-8 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none appearance-none cursor-pointer">
              <option [ngValue]="null">-- ไม่ระบุ --</option>
              <option *ngFor="let r of rates" [ngValue]="r.id">{{ r.name }}</option>
            </select>
            <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
          </div>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Gate Group</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">door_front</span>
          <select [(ngModel)]="formData.gateGroupId"
            class="w-full pl-10 pr-8 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none appearance-none cursor-pointer">
            <option [ngValue]="null">-- ไม่ระบุ --</option>
            <option *ngFor="let g of gateGroups" [ngValue]="g.id">{{ g.name }}</option>
          </select>
          <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
        <div class="relative flex items-start bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30">
          <span class="absolute left-3 top-3 material-icons text-slate-400 text-[20px]">notes</span>
          <textarea rows="3" placeholder="หมายเหตุเพิ่มเติม" [(ngModel)]="formData.remark"
            class="w-full pl-10 pr-4 py-3 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none resize-none placeholder:text-slate-400"></textarea>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
          ประเภทรถ
          <span *ngIf="formData.isFreeParking" class="text-rose-500">*</span>
        </label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">directions_car</span>
          <select [(ngModel)]="formData.vehicleTypeId"
            class="w-full pl-10 pr-8 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none appearance-none cursor-pointer">
            <option [ngValue]="null">-- เลือกประเภทรถ --</option>
            <option *ngFor="let v of vehicleTypes" [ngValue]="v.id">{{ v.name }}</option>
          </select>
          <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
        </div>
        <p *ngIf="formData.isFreeParking" class="mt-1.5 text-xs text-sky-600 dark:text-sky-400">
          จำเป็นสำหรับ Subscription จอดฟรี — ใช้หักโควต้าตามประเภทรถ
        </p>
      </div>

      <label class="flex items-center gap-3 cursor-pointer p-3 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700 w-fit">
        <input type="checkbox" [(ngModel)]="formData.isOnline"
          class="w-4 h-4 rounded border-slate-300 text-emerald-500 focus:ring-emerald-400">
        <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Online</span>
      </label>

      <label class="flex items-start gap-3 cursor-pointer p-3 rounded-xl bg-sky-50 dark:bg-sky-950/30 border border-sky-100 dark:border-sky-800/40 w-full">
        <input type="checkbox" [(ngModel)]="formData.isFreeParking"
          class="mt-0.5 w-4 h-4 rounded border-slate-300 text-sky-600 focus:ring-sky-400">
        <span>
          <span class="block text-sm font-semibold text-slate-700 dark:text-slate-200">จอดฟรี (is_free_parking)</span>
          <span class="block text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            เปิดแล้วจะกินโควต้าจอดฟรี และเลือกได้ในกลุ่มสิทธิ์ / โควต้าลาน
          </span>
        </span>
      </label>
    </div>

    <div class="flex justify-between gap-3 mt-8 pt-6 border-t border-slate-100 dark:border-slate-800">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex justify-end gap-3 ml-auto">
        <button type="button" (click)="onClose()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl font-bold text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl font-bold bg-amber-400 hover:bg-amber-500 text-white shadow-lg shadow-amber-200/50 dark:shadow-amber-900/20 transition-all disabled:opacity-60 flex items-center gap-2">
          <span *ngIf="isSaving()" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && editRow?.id"
  [entityType]="activityEntityTypes.ParkingSubscription"
  [entityId]="editRow!.id"
  title="ประวัติแพ็กเกจสมาชิก"
  [subtitle]="'#' + editRow!.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
